import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-gravatar',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Gravatar icon</title><path d="M12 0c-1.326 0-2.4 1.074-2.4 2.4v8.4c0 1.324 1.074 2.398 2.4 2.398s2.4-1.074 2.4-2.398V5.21c2.795.99 4.799 3.654 4.799 6.789 0 3.975-3.225 7.199-7.199 7.199S4.801 15.975 4.801 12c0-1.989.805-3.789 2.108-5.091.938-.938.938-2.458 0-3.396s-2.458-.938-3.396 0C1.344 5.686 0 8.686 0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0"/></svg>`,
    styles: []
})
export class SimpleIconsGravatarComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#1E8CBE';
    @Input() className: string = 'simple-icons-gravatar'
    constructor() {}
    ngOnInit(): void {}
}
